<template>
    <PublicProfileLayout>
        <!-- Hero / Banner Section -->
        <VideoSection />
        <div class="background-image " :style="{ backgroundImage: `linear-gradient(rgba(255,255,255,0.65), rgba(255,255,255,0.65)),url('${bgUrl}')` }">
            <!-- Our Story Section -->
            <OurStorySection />

            <!-- Vision & Mission Section -->
            <VisionSection />

            <!-- Features Grid -->
            <FeatureSection />
        </div>

        <!-- Join as an Institute Section -->
        <CommunitySection :imageUrl="Image" title=""
            description="ILearn’d Tutors is more than a tutoring platform — it’s a smarter, more engaging way to learn. With easy scheduling, chat, notes, homework tools, and access to past papers and textbooks, students get everything they need in one place. Our technology makes learning simple, interactive, and enjoyable, turning every lesson into an experience that inspires growth."
            label="" />

        <!-- Bridging the Gap Section -->
        <BridgingGapSection />

        <!-- Contact Form Section -->
        <ContactFormSection :image="contactImage" />

    </PublicProfileLayout>
</template>

<script setup>
import { onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import PublicProfileLayout from "@/layout/PublicProfileLayout.vue";
import OurStorySection from "@/components/landingPage/aboutUsPage/ourStorySection.vue"
import VisionSection from "@/components/landingPage/aboutUsPage/visionSection.vue"
import CommunitySection from "@/components/landingPage/commonSections/communitySection.vue"
import BridgingGapSection from "@/components/landingPage/aboutUsPage/bridgingGapSection.vue"
import FeatureSection from "@/components/landingPage/aboutUsPage/featureSection.vue"
import ContactFormSection from "@/components/landingPage/commonSections/contactFormSection.vue"
import VideoSection from "@/components/landingPage/aboutUsPage/videoSection.vue"
import contactImage from "@/assets/Images/tiger.png"
import { usePublicUrl } from "@/utils/getPublicUrl"

const Image = "public/child.jpg"
const bgUrl = usePublicUrl("public/how-it-works.jpg");
const route = useRoute();

onMounted(async () => {
    if (route.query.scrollTo) {
        await nextTick();
        // Delay to allow all page sections (images, components) to fully render
        setTimeout(() => {
            const el = document.getElementById(route.query.scrollTo);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);
    }
});
</script>

<style scoped>

.background-image {
    position: relative;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 0px;
    margin: 0px;
}

.background-image::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.23);
    pointer-events: none; 
}
/* Responsive Styles */
@media (max-width: 767px) {
    .hero-section {
        height: 350px;
    }

    .overlay-content h1 {
        font-size: 1.5rem;
    }

    .overlay-content p {
        font-size: 0.9rem;
    }

    .why-section {
        padding: 2rem 1rem;
    }
}
</style>
